module.exports = __webpack_public_path__ + "img/s2-img3.400d749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s2-img3.png
// module id = 409
// module chunks = 0